import React, { Fragment, useState, useEffect } from 'react'
import TablaPY from "../TablaPY";
import PDF from '../PDF/PDFURL'
import Tabla, { Head, Row, Cell, Body } from '../../Components/Tabla/Tabla';
import { getPDF } from "../PDF/Fetch/getPDF";
export default function PYCurves() {

    const [view, setView] = useState({
        showPDF: false,
        base64: ''
    })

    const [data, setData] = useState({
        config: {
            margen: 5,
            margenL: 10,
            margenR: 10,
            margenB: 5,
            margenT: 5,
            CellBorder: 0,
            H_Cabecera: 20,
            margenSondeo: 0.2,
            col1: 0.15,
            esp_temp_name: 0.05,
            esp_temp_data: 0.8,
            imgconfig: [
                {
                    aspect: 0.9,
                    posx: 0,
                    posy: 0,
                },
                {
                    aspect: 0.9,
                    posx: 0,
                    posy: 0,
                },
                {
                    aspect: 0.9,
                    posx: 0,
                    posy: 0,
                }
            ]
        },

        input: {
            Sondeo: '',
            Figura: '',
            Format: 0,
            Sitio: '',
            Lugar: '',
            DiameterIN: 1,
            Diameterdecimals: 0,
            Profdecimals: 2,
            Tabledecimals: 4,
        },
        data: []
    })

    const [config, setConfig] = useState(
        {
            inputs: [
                {
                    name: 'TipoTabla', placeholder: 'Tipo de Formato', type: 'select', value: 0,
                    options: [
                        {
                            name: 'Datos p-y (Carga Estática)', value: 0, tit: 'p-y (Carga Estática)'
                        },
                        {
                            name: 'Datos p-y (Carga Cíclica)', value: 1, tit: 'p-y (Carga Cíclica)'
                        },
                        {
                            name: 'DATOS DE TRANSFERENCIA DE CARGA AXIAL Datos T-z', value: 2, tit: 'T-z'
                        },
                        {
                            name: 'DATOS DE TRANSFERENCIA DE CARGA AXIAL Datos Q-z', value: 3, tit: 'Q-z'
                        }
                    ]
                },
                { name: 'Diametro', placeholder: 'Diametro de Pilote', type: 'diam', value: 1 },
                { name: 'Sondeo', placeholder: 'Sondeo', type: 'text', value: '' },
                { name: 'Figura', placeholder: 'Figura', type: 'text', value: '' },
                { name: 'Diametro_Decimales', placeholder: 'Decimales Diametro', type: 'text', value: 0 },
                { name: 'Prof_Decimales', placeholder: 'Decimales Profundidad', type: 'text', value: 2 },
                { name: 'Table_Decimales', placeholder: 'Decimales Celdas', type: 'text', value: 4 }
            ],
            doc: [
                { name: 'margen', placeholder: 'Margen Imagen', type: 'int', value: 5 },
                { name: 'margenL', placeholder: 'Margen Izquierdo', type: 'int', value: 10 },
                { name: 'margenR', placeholder: 'Margen Derecho', type: 'int', value: 10 },
                { name: 'margenT', placeholder: 'Margen Superior', type: 'int', value: 5 },
                { name: 'margenB', placeholder: 'Margen Inferior', type: 'int', value: 5 },
                { name: 'marH_CabeceragenB', placeholder: 'Alto de Cabecera', type: 'int', value: 20 },
                { name: 'margen_Sondeo', placeholder: '% Margen Sondeo', type: 'int', value: 0.2 },
            ],
            imgpos: [
                [
                    { name: 'aspect', placeholder: 'Aspecto', type: 'int', value: 0.9 },
                    { name: 'posx', placeholder: 'X', type: 'int', value: 0 },
                    { name: 'posy', placeholder: 'Y', type: 'int', value: 0 }
                ],
                [
                    { name: 'aspect', placeholder: 'Aspecto', type: 'int', value: 0.9 },
                    { name: 'posx', placeholder: 'X', type: 'int', value: 0 },
                    { name: 'posy', placeholder: 'Y', type: 'int', value: 0 }
                ],
                [
                    { name: 'aspect', placeholder: 'Aspecto', type: 'int', value: 0.9 },
                    { name: 'posx', placeholder: 'X', type: 'int', value: 0 },
                    { name: 'posy', placeholder: 'Y', type: 'int', value: 0 }
                ]
            ]
        }
    )

    useEffect(() => {
        if (localStorage.getItem("GEOMECPYS")) {
            let configT = JSON.parse(localStorage.getItem("GEOMECPYS"))
            setConfig(configT)
            document.title = configT.inputs.filter(el => el.name === 'TipoTabla')[0].options[configT.inputs.filter(el => el.name === 'TipoTabla')[0].value].tit;

            setData(d => ({
                ...d,
                input: {
                    ...d.input,
                    Format: parseInt(configT.inputs.filter(el => el.name === 'TipoTabla')[0].value),
                    Sondeo: configT.inputs.filter(el => el.name === 'Sondeo')[0].value,
                    Figura: configT.inputs.filter(el => el.name === 'Figura')[0].value,
                    DiameterIN: parseFloat(configT.inputs.filter(el => el.name === 'Diametro')[0].value),
                    Diameterdecimals: parseInt(configT.inputs.filter(el => el.name === 'Diametro_Decimales')[0].value),
                    Profdecimals: parseInt(configT.inputs.filter(el => el.name === 'Prof_Decimales')[0].value),
                    Tabledecimals: parseInt(configT.inputs.filter(el => el.name === 'Table_Decimales')[0].value),
                },
                config: {
                    ...d.config,
                    margen: parseFloat(configT.doc.filter(el => el.name === 'margen')[0].value),
                    margenL: parseFloat(configT.doc.filter(el => el.name === 'margenL')[0].value),
                    margenR: parseFloat(configT.doc.filter(el => el.name === 'margenR')[0].value),
                    margenB: parseFloat(configT.doc.filter(el => el.name === 'margenB')[0].value),
                    margenT: parseFloat(configT.doc.filter(el => el.name === 'margenT')[0].value),
                    H_Cabecera: parseFloat(configT.doc.filter(el => el.name === 'marH_CabeceragenB')[0].value),
                    margenSondeo: parseFloat(configT.doc.filter(el => el.name === 'margen_Sondeo')[0].value),
                    imgconfig: d.config.imgconfig.map((im, iim) => (
                        {
                            ...im,
                            aspect: parseFloat(configT.imgpos[iim].filter(el => el.name === 'aspect')[0].value),
                            posx: parseFloat(configT.imgpos[iim].filter(el => el.name === 'posx')[0].value),
                            posy: parseFloat(configT.imgpos[iim].filter(el => el.name === 'posy')[0].value)
                        }
                    ))
                }
            }))
        } else {
            document.title = 'p-y (Carga Estática)';
        }
    }, [setConfig])


    function onChange(e, ind, lbl) {
        e.preventDefault();
        console.log(lbl, ind)
        if (ind <= 0) {
            document.title = config.inputs.filter(el => el.name === 'TipoTabla')[0].options[e.target.selectedOptions[0].value].tit;
        }


        setConfig(v => ({
            ...v,
            [lbl]: v[lbl].map((el, i) => ({
                ...el,
                value: ind === i ? e.target.value : el.value
            }))
        })
        )
        setData(d => ({
            ...d,
            input: {
                ...d.input,
                Format: config[lbl][ind].name === 'TipoTabla' ? parseInt(e.target.value) : d.input.Format,
                Sondeo: config[lbl][ind].name === 'Sondeo' ? e.target.value : d.input.Sondeo,
                Figura: config[lbl][ind].name === 'Figura' ? e.target.value : d.input.Figura,
                DiameterIN: config[lbl][ind].name === 'Diametro' ? parseFloat(e.target.value) : d.input.DiameterIN,
                Diameterdecimals: config[lbl][ind].name === 'Diametro_Decimales' ? parseInt(e.target.value) : d.input.Diameterdecimals,
                Profdecimals: config[lbl][ind].name === 'Prof_Decimales' ? parseInt(e.target.value) : d.input.Profdecimals,
                Tabledecimals: config[lbl][ind].name === 'Table_Decimales' ? parseInt(e.target.value) : d.input.Tabledecimals
            },
            config: {
                ...d.config,
                margen: config[lbl][ind].name === 'margen' ? parseFloat(e.target.value) : d.config.margen,
                margenL: config[lbl][ind].name === 'margenL' ? parseFloat(e.target.value) : d.config.margenL,
                margenR: config[lbl][ind].name === 'margenR' ? parseFloat(e.target.value) : d.config.margenR,
                margenB: config[lbl][ind].name === 'margenB' ? parseFloat(e.target.value) : d.config.margenB,
                margenT: config[lbl][ind].name === 'margenT' ? parseFloat(e.target.value) : d.config.margenT,
                H_Cabecera: config[lbl][ind].name === 'marH_CabeceragenB' ? parseFloat(e.target.value) : d.config.H_Cabecera,
                margenSondeo: config[lbl][ind].name === 'margen_Sondeo' ? parseFloat(e.target.value) : d.config.margenSondeo,
            }
        }))
    }

    function onChange2(e, ind, lbl, ind2) {
        e.preventDefault();
        setConfig(v => ({
            ...v,
            [lbl]: v[lbl].map((el, i) => (
                el.map((el2, i2) => ({
                    ...el2,
                    value: ind === i && ind2 === i2 ? e.target.value : el2.value
                }))
            ))
        })
        )
        setData(d => ({
            ...d,
            config: {
                ...d.config,
                imgconfig: d.config.imgconfig.map((el, indx) => ({
                    ...el,
                    aspect: indx === ind && ind2 === 0 ? parseFloat(e.target.value) : el.aspect,
                    posx: indx === ind && ind2 === 1 ? parseFloat(e.target.value) : el.posx,
                    posy: indx === ind && ind2 === 2 ? parseFloat(e.target.value) : el.posy
                }))
            }
        }))
    }

    function MatchValues(data) {
        let temp = []
        for (let index = 0; index < data.length; index++) {
            temp.push(data[index].filter((_, ind) => ind !== 1))
        }
        return temp;
    }

    function onSubmit(e) {
        e.preventDefault();
        getPDF(data.config, data.input, MatchValues(data.data)).then(res => {
            setView(v => ({
                ...v,
                showPDF: true,
                base64: res
            }))
            localStorage.setItem("GEOMECPYS", JSON.stringify(config))
        }
        )
    }

    function RegresarT(e, sw) {
        e.preventDefault()
        setView(v => ({
            ...v,
            showPDF: sw
        }))
    }

    return (
        <div>
            <form style={{ height: 'auto', width: '100%', float: 'left', display: view.showPDF === true ? 'none' : 'block' }} onSubmit={onSubmit}>

                <Tabla border={1} style={{ height: '100%', float: 'left', display: 'block', background: 'yellow' }}>
                    <Body>
                        <Row>
                            <Cell colSpan={2}><b>Entrada de Datos</b></Cell>
                        </Row>
                        {config.inputs.map((el, ind) => {
                            switch (el.type) {
                                case 'select':
                                    return (
                                        <Row key={ind}>
                                            <Cell>{el.placeholder}</Cell>
                                            <Cell>
                                                <select value={el.value}
                                                    onChange={(e) => { onChange(e, ind, 'inputs') }}
                                                >
                                                    {
                                                        el.options.map((op, opi) => (
                                                            <option key={opi} value={op.value}>{op.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </Cell>
                                        </Row>
                                    )
                                case 'diam':
                                    return (
                                        <Row key={ind}>
                                            <Cell>{el.placeholder}</Cell>
                                            <Cell>
                                                <input type='text' placeholder={el.placeholder}
                                                    pattern='^[0-9]+$|^[0-9]+[.]{1}$|^[0-9]+[.]{1}[0-9]{1,4}'
                                                    value={parseFloat(el.value)}
                                                    onChange={(e) => {
                                                        onChange(e, ind, 'inputs')
                                                    }}
                                                />
                                                <b>{parseFloat(el.value).toFixed(2)} In ({parseFloat(el.value * 25.4).toFixed(2)}mm)</b>
                                            </Cell>
                                        </Row>
                                    )
                                case 'text':
                                    return (
                                        <Row key={ind}>
                                            <Cell>{el.placeholder}</Cell>
                                            <Cell>
                                                <input type='text' value={el.value} placeholder={el.placeholder}
                                                    onChange={(e) => { onChange(e, ind, 'inputs') }}
                                                />
                                            </Cell>
                                        </Row>
                                    )
                                case 'int':
                                    return (
                                        <Row key={ind}>
                                            <Cell>{el.placeholder}</Cell>
                                            <Cell>
                                                <input type='text' value={el.value} placeholder={el.placeholder}
                                                    pattern='^[0-9]+$|^[0-9]+[.]{1}$|^[0-9]+[.]{1}[0-9]{1,4}'
                                                    onChange={(e) => { onChange(e, ind, 'inputs') }}
                                                />
                                            </Cell>
                                        </Row>
                                    )
                                default:
                                    return (
                                        <Row key={ind}>
                                            <Cell>{el.placeholder}</Cell>
                                        </Row>
                                    )
                            }
                        }
                        )}
                        <Row>
                            <Cell colSpan='2'>
                                <button type='submit'>Generar PDF</button>
                                {
                                    view.base64 !== '' ?
                                        <button type='button' onClick={(e) => { RegresarT(e, true) }}>Regresar a PDF</button>
                                        : ''
                                }

                            </Cell>
                        </Row>
                    </Body>
                </Tabla>
                <Tabla border={1} style={{ height: '100%', float: 'left', display: 'block', background: 'cyan' }}>
                    <Head>
                        <Row><Cell colSpan={2}><b>Imagenes</b></Cell></Row>
                    </Head>
                    <Body>
                        {config.doc.map((el, ind) => (

                            <Row key={ind}>
                                <Cell>{el.placeholder}</Cell>
                                <Cell>
                                    <input placeholder={el.placeholder}
                                        value={el.value}
                                        pattern='^[0-9]+$|^[0-9]+[.]{1}$|^[0-9]+[.]{1}[0-9]{1,4}'
                                        onChange={(e) => { onChange(e, ind, 'doc') }}
                                    />
                                </Cell>
                            </Row>

                        ))}

                    </Body>
                </Tabla>
                <Tabla border={1} style={{ height: '100%', float: 'left', display: 'block', background: 'orange' }}>
                    <Head>
                        <Row><Cell colSpan={2}><b>Margenes</b></Cell></Row>
                    </Head>
                    <Body>
                        {config.imgpos.map((imgs, iimgs) => (
                            <Fragment key={iimgs}>
                                <Row>
                                    <Cell colSpan={2}><b>Configuracion de Imagen {iimgs + 1}</b></Cell>
                                </Row>

                                {imgs.map((lbl, ilbl) => (


                                    <Row key={ilbl}>
                                        <Cell>{lbl.placeholder}</Cell>
                                        <Cell>
                                            <input placeholder={lbl.placeholder}
                                                value={lbl.value}
                                                pattern='^[0-9.-]+'
                                                onChange={(e) => { onChange2(e, iimgs, 'imgpos', ilbl) }}
                                            />
                                        </Cell>
                                    </Row>

                                ))}
                            </Fragment>

                        ))}

                    </Body>
                </Tabla>


            </form>
            <div style={{ display: view.showPDF === true ? 'none' : 'block', float: 'left', width: '100%' }}>
                <TablaPY set={setData} />
            </div>
            <div style={{ display: view.showPDF === false ? 'none' : 'block' }}>
                <button type='button' onClick={(e) => { RegresarT(e, false) }}>Regresar a Tabla</button>
                <PDF base64data={view.base64} />
            </div>
        </div>
    )
}
